import { FC, useEffect, useState } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import metamask from "../../assets/images/icons/metamask.svg";
import arrow from "../../assets/images/arrow.svg";
import { Box, Grid, Container } from "@material-ui/core";
import dottedlines from "../../assets/images/dottedlines.svg";
import useStyles from "../Styles/StepperStyles";
import stepperConnectIcon from "../../assets/images/stepperConnectIcon.svg";
import { useAccount } from "wagmi";
const HorizontalNonLinearAlternativeLabelStepper: FC<any> = ({
  sendFundCompleteStep,
}) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(1);
  const [completed, setCompleted] = useState(new Set([0]));
  const [skipped, setSkipped] = useState(new Set());
  const { address: account } = useAccount();
  const steps = getSteps();
  let stepperIndexValue = 1;
  function getSteps() {
    return ["Whitelist", "Invest", "Claim Token"];
  }

  const Arrow = () => {
    return <img src={arrow} alt="gains" />;
  };

  const Warning = () => {
    return (
      <img src={dottedlines} className="img-fluid warningimg" alt="warning" />
    );
  };
  const Success = () => {
    return (
      <img
        src={stepperConnectIcon}
        className="img-fluid warningimg"
        alt="success"
      />
    );
  };

  useEffect(() => {
    if (sendFundCompleteStep) {
      completed.add(stepperIndexValue);
      setActiveStep(1);
    }
  }, [sendFundCompleteStep]);

  const handleStep = (step: number) => () => {
    setActiveStep(step);
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  function isStepComplete(step: number) {
    return completed.has(step);
  }
  const Icon = () => {
    return <img src={metamask} alt="GAINS" />;
  };

  return (
    <>
      <Box className={classes.root}>
        <Container fixed>
          <Grid container>
            <Grid item md={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                className="xs-overflow"
              >
                <Box
                  mr={1}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  className="warningline"
                  position="relative"
                  top={15}
                >
                  <Box>
                    <Button
                      variant="outlined"
                      className="connect-button"
                      color={account ? "primary" : "secondary"}
                      startIcon={<Icon />}
                    >
                      Connect to a wallet
                    </Button>
                  </Box>
                  <Box mt="12px">
                    <Typography variant="subtitle1" className="color fw-normal">
                      {account ? (
                        account?.length > 5 ? (
                          account.substr(0, 6) +
                          "..." +
                          account.substr(account.length - 4, account.length)
                        ) : (
                          account
                        )
                      ) : (
                        <span style={{ opacity: "0" }}>asd</span>
                      )}
                    </Typography>
                  </Box>
                </Box>
                {account ? <Success /> : <Warning />}
                <Box>
                  <Stepper
                    alternativeLabel
                    nonLinear
                    activeStep={activeStep}
                    connector={<Arrow />}
                  >
                    {steps.map((label, index) => {
                      const stepProps: any = {};
                      const buttonProps = {};

                      if (isStepSkipped(index)) {
                        stepProps.completed = false;
                      }
                      return (
                        <Step key={index} {...stepProps}>
                          <StepButton
                            onClick={handleStep(index)}
                            completed={isStepComplete(index)}
                            {...buttonProps}
                          >
                            {label}
                          </StepButton>
                        </Step>
                      );
                    })}
                  </Stepper>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default HorizontalNonLinearAlternativeLabelStepper;
